var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "background-spinner" },
    [
      _c("spinner", {
        staticClass: "background-spinner-spinner",
        attrs: { "line-fg-color": "#c6e0a7", size: 64, "line-size": 12 }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "background-spinner-clear" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03a2f6d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a2f6d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/backend/components/BackgroundSpinner.vue
// module id = 165
// module chunks = 1